/**
 * Whether an element has come within `margin` of the viewport: once true it
 * stays true (a section fetches once it is near, #2291). The same observer
 * as the card previews (`useModelPreview`). Where there is no
 * IntersectionObserver, everything counts as near.
 */
import { useEffect, useRef, useState } from 'react';

export function useNearViewport<T extends Element>(margin = '200px') {
  const ref = useRef<T | null>(null);
  const supported = typeof IntersectionObserver !== 'undefined';
  const [near, setNear] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!supported || near || !node) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setNear(true);
          observer.disconnect();
        }
      },
      { rootMargin: margin },
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [supported, near, margin]);

  return { ref, near: near || !supported };
}
